﻿import { MarkerClusterer } from "@googlemaps/markerclusterer";
import OverlappingMarkerSpiderfier from "./oms";
import { createBigSpinner } from "./spinner";
import { loadGoogleMapApiAsync } from "./googlemap";
import { dbfetch } from "./dbfetch";
// import { createElement } from "./_dom";

function selectMarker(marker, showMarker) {
	marker.setVisible(showMarker);
}

async function loadImageAsDataURLAsync(url) {
	const response = await dbfetch(url);
	const blob = await response.blob();
	const dataUrl = await blobToDataUrl(blob);
	return dataUrl;
}

async function blobToDataUrl(blob) {
	return new Promise((resolve) => {
		const reader = new FileReader();
		reader.onloadend = () => resolve(reader.result);
		reader.readAsDataURL(blob);
	});
}

const getBaseSvgIcon = (color, scale, deltaX = 16 * scale, deltaY = 10 * scale) => `
	<filter  filterUnits="objectBoundingBox" id="shadow" width="${100 + 2 * deltaX}%" height="${100 + 2.5 * deltaY}%" x="-${deltaX}%" y="-${deltaY}%">
		<feOffset  dx="0" dy="${2 * scale}" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
		<feGaussianBlur  in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="2"></feGaussianBlur>
		<feColorMatrix  in="shadowBlurOuter1" type="matrix" values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.21216674 0"></feColorMatrix>
	</filter>
	<g>
		<g style="filter:url(#shadow)">
			<path style="fill-rule:evenodd; clip-rule:evenodd;" d="M27.8,68C44,53.8,55.7,43.2,55.7,27.8S43.2,0,27.8,0S0,12.5,0,27.8S12.1,53.9,27.8,68z"/>
		</g>
		<g>
			<path style="fill-rule:evenodd;clip-rule:evenodd; fill:${color || `#FFFFFF` };" d="M27.8,68C44,53.8,55.7,43.2,55.7,27.8S43.2,0,27.8,0S0,12.5,0,27.8S12.1,53.9,27.8,68z"/>
		</g>
	</g>`;


/*
function svgToNode(icon, color) {
	const svg = createElement("img", { width: 56, height: 68, src: svgToData(icon, color) });
	return svg;
}
*/

const noImgIcon = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNi4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0i0KHQu9C+0LlfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCA0OCA0OCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDggNDg7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtvcGFjaXR5OjAuMDg7ZmlsbDojMEMwQzBEO3N0cm9rZTojMDAwMDAwO3N0cm9rZS1taXRlcmxpbWl0OjEwO30NCgkuc3Qxe2ZpbGw6bm9uZTt9DQoJLnN0MntvcGFjaXR5OjAuMjt9DQoJLnN0M3tmaWxsOiMwQzBDMEQ7fQ0KCS5zdDR7b3BhY2l0eTowLjI7ZmlsbDojMEMwQzBEO30NCjwvc3R5bGU+DQo8Zz4NCgk8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQsNDhMMjQsNDhDMTAuNzUsNDgsMCwzNy4yNSwwLDI0djBDMCwxMC43NSwxMC43NSwwLDI0LDBoMGMxMy4yNSwwLDI0LDEwLjc1LDI0LDI0djANCgkJQzQ4LDM3LjI1LDM3LjI1LDQ4LDI0LDQ4eiIvPg0KCTxnPg0KCQk8cmVjdCB4PSIxMCIgeT0iMTAiIGNsYXNzPSJzdDEiIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIvPg0KCQk8Zz4NCgkJCTxnIGNsYXNzPSJzdDIiPg0KCQkJCTxwYXRoIGNsYXNzPSJzdDMiIGQ9Ik0zMi41LDE0LjV2OC4yMWgtMTdWMTQuNUgzMi41IE0zNS41LDExLjVoLTIzdjE0LjIxaDIzVjExLjVMMzUuNSwxMS41eiIvPg0KCQkJPC9nPg0KCQkJPHJlY3QgeD0iMTIuNSIgeT0iMzQuNCIgY2xhc3M9InN0NCIgd2lkdGg9IjIzIiBoZWlnaHQ9IjIuMSIvPg0KCQkJPHJlY3QgeD0iMTIuNSIgeT0iMjkuMDEiIGNsYXNzPSJzdDQiIHdpZHRoPSIyMyIgaGVpZ2h0PSIyLjEiLz4NCgkJPC9nPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K';

async function renderMapViewInner(googleMaps, mapContainer, options) {
	let center = { lat: 0, lng: 0 }, zoom = 1, hasBounds = false, hasImages = false;
	const bounds = { north: -200, east: -200, south: 200, west: 200 };
	if (options.pins.length > 0) {
		zoom = 17;
		for (let i = 0; i < options.pins.length; i++) {
			const pin = options.pins[i];
			hasImages |= !!pin.image;
			bounds.north = Math.max(bounds.north, pin.lat);
			bounds.south = Math.min(bounds.south, pin.lat);
			bounds.east = Math.max(bounds.east, pin.lng);
			bounds.west = Math.min(bounds.west, pin.lng);
		}
		center = { lat: (bounds.north + bounds.south) / 2, lng: (bounds.east + bounds.west) / 2 };
		hasBounds = options.pins.length > 1;
	}

	const getPhotoIcon = hasImages ? (img) =>
		`<g>
			<defs>
				<path id="mask-id" d="M28,52L28,52C14.75,52,4,41.25,4,28v0C4,14.75,14.75,4,28,4h0c13.25,0,24,10.75,24,24v0C52,41.25,41.25,52,28,52z"/>
			</defs>
			<clipPath id="mask">
				<use xlink:href="#mask-id"  style="overflow:visible;"/>
			</clipPath>
			<image xlink:href="${img}" height="48" width="48" x="4px" y="4px" style="clip-path:url(#mask);" preserveAspectRatio="xMidYMid slice"/>
		</g>` : () => `<circle cx="28" cy="28" r="6" fill="transparent" stroke="#0D0D0E" stroke-width="2" stroke-opacity=".7"/>`;


	function svgToData(icon, color) {
		const scale = hasImages ? 1 : 0.5;
		const shadowScale = hasImages ? 1 : 4;
		const w = 56 * scale, h = 68 * scale;
		const svg = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" width="${w}" height="${h}" viewBox="0 0 56 68">${getBaseSvgIcon(color, shadowScale)}${icon}</svg>`;
		return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
	}

	function createMarker(type, marker, count) {
		let icon, markerIcon;
		switch (type) {
			case 'spider':
				icon = `<g transform="translate(18, 16)">
				<path fill="#0D0D0E" d="M19,9 L11,9 L11,1 C11,0.45 10.55,0 10,0 C9.45,0 9,0.45 9,1 L9,9 L1,9 C0.45,9 0,9.45 0,10 C0,10.55 0.45,11 1,11 L9,11 L9,19 C9,19.55 9.45,20 10,20 C10.55,20 11,19.55 11,19 L11,11 L19,11 C19.55,11 20,10.55 20,10 C20,9.45 19.55,9 19,9 Z"/>
				</g>`;
				markerIcon = svgToData(icon, marker.pinData?.color);
				marker.setIcon(markerIcon);
				marker.markerType = type;
				break;
			case 'clusterer':
				icon = `<g>
					<circle cx="28" cy="28" r="24" fill="#0D0D0E"/>
					<text dx="50%" dy="50%" text-anchor="middle" fill="#FFFFFF" style="font:bold 22px/1 sans-serif">${count}</text>
				</g>`;
				markerIcon = svgToData(icon, marker.pinData?.color);
				marker.setIcon(markerIcon);
				marker.markerType = type;
				break;
			case 'base':
				icon = getPhotoIcon(marker.pinData.imageDataURL || noImgIcon);
				markerIcon = svgToData(icon, marker.pinData.color);
				marker.setIcon(markerIcon);
				marker.markerType = type;
				if (marker.pinData.image && !marker.pinData.imageDataURL) {
					loadImageAsDataURLAsync(marker.pinData.image).then(imageDataURL => {
						marker.pinData.imageDataURL = imageDataURL;
						if (marker.markerType === "base") {
							icon = getPhotoIcon(imageDataURL);
							markerIcon = svgToData(icon, marker.pinData.color);
							marker.setIcon(markerIcon);
						}
					});
				}
				break;
		}
	}

	function initInteractiveView(googleMaps, mapContainer) {
		let currentInfoWindow, currentMarker;

		const map = new googleMaps.Map(mapContainer, {
			mapTypeId: options.type,
			center: center
		});

		function iwClose() {
			if (currentInfoWindow) {
				currentInfoWindow.close();
				iwCloseCallback();
			}
		}

		function iwCloseCallback() {
			currentInfoWindow = null;
			selectMarker(currentMarker, true);
			currentMarker = null;
		}

		function iwOpen(marker) {
			iwClose();
			const id = marker.pinData.id;
			currentMarker = marker;
			selectMarker(currentMarker, false);
			currentInfoWindow = new googleMaps.InfoWindow({ content: document.getElementById(id).cloneNode(true), maxWidth: 640, position: { lat: marker.pinData.lat, lng: marker.pinData.lng } });
			currentInfoWindow.open(map);
			googleMaps.event.addListener(currentInfoWindow, "closeclick", iwCloseCallback);
		}

		map.addListener("click", iwClose);

		const markers = options.pins.map(pin => {
			const marker = new googleMaps.Marker({
				map,
				position: { lat: pin.lat, lng: pin.lng },
				title: pin.title,
			});
			marker.pinData = pin;
			return marker;
		});
		let markersCount = markers.length;

		const oms = new OverlappingMarkerSpiderfier(map, {
			markersWontMove: true,
			markersWontHide: true,
			keepSpiderfied: true,
			nearbyDistance: 56,
			circleSpiralSwitchover: 6,
			circleFootSeparation: 50,
			spiralFootSeparation: 50,
			spiralLengthStart: 25,
			spiralLengthFactor: 8
		});
		const mapType = options.type;
		oms.legColors.usual[mapType] = '#D0D0E0';
		oms.legColors.highlighted[mapType] = '#0D0D0E';
		oms.addListener("format", (marker, status) => {
			if (markersCount !== 0) markersCount--;
			switch (status) {
				case OverlappingMarkerSpiderfier.markerStatus.SPIDERFIABLE:
				case OverlappingMarkerSpiderfier.markerStatus.UNSPIDERFIED:
					createMarker('spider', marker);
					break;
				default:
					createMarker('base', marker);
			}
		});

		if (options.cluster) {
			new MarkerClusterer({
				map,
				markers,
				renderer: {
					render: ({ count, position }) => {
						const clusterMarker = new googleMaps.Marker({
							// map,
							position,
							zIndex: Number(googleMaps.Marker.MAX_ZINDEX) + count,
						});
						createMarker('clusterer', clusterMarker, count);
						return clusterMarker;
					}
				}
			});
			map.addListener("zoom_changed", function () {
				googleMaps.event.addListenerOnce(map, "idle", function () {
					oms.formatMarkers();
				});
			});
		}

		googleMaps.event.addListenerOnce(map, "idle", function initAfterIdle() {
			markers.forEach(m => oms.trackMarker(m, () => iwOpen(m)));
			oms.formatMarkers();
			if (hasBounds) {
				map.fitBounds(bounds);
			} else {
				map.setZoom(zoom);
			}
		});
	}

	initInteractiveView(googleMaps, mapContainer);
}

async function init(context, selector = "") {
	// get aspect;
	const bodyFrame = document.getElementById("td-bodyframe");
	let aspect;
	if (bodyFrame) {
		const availWidth = bodyFrame.offsetWidth;
		let top = 0;
		for (let x = bodyFrame; x; x = x.offsetParent)
			top += x.offsetTop;
		const availHeight = window.innerHeight - top;
		if (availWidth < 2 * availHeight)
			aspect = `${availWidth} / ${availHeight}`;
	}
	const elements = (context || document).querySelectorAll(selector + "[data-js-map-options]");
	if (elements.length) {
		elements.forEach(mapContainer => {
			const spinner = createBigSpinner();
			mapContainer.append(spinner);
		});
		const googleMaps = await loadGoogleMapApiAsync(["marker", "places"]);
		elements.forEach(mapContainer => {
			mapContainer.replaceChildren();
			const options = JSON.parse(mapContainer.dataset.jsMapOptions);
			mapContainer.removeAttribute("data-js-map-options");
			if (aspect) {
				mapContainer.parentElement.style.aspectRatio = aspect;
			}
			renderMapViewInner(googleMaps, mapContainer, options);
		});
	}
}

export { init };